import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../common/context/';
import styles from '../CustomNode.module.css';
import { Props } from './customNodeProps';

/**
 * Este componente renderiza cada nodo del arbol dependiendo de los parametros que le enviemos
 * @param props
 * @returns Cada nodo del arbol
 */
export const CustomNode: React.FC<Props> = (props) => {
    const { isSkinSmart } = useContext(AppContext);

    const { droppable, data } = props.node;
    const indent = props.depth * 24;

    const [isDroppable, setIsDroppable] = useState(false);

    const handleToggle = () => {
        if (props.node.droppable) {
            // e.stopPropagation();
            props.onToggle(props.node.id);
        }
    };

    const handleSelect = () => props.onSelect(props.node);

    useEffect(() => {
        if (props.searchValue) {
            handleToggle();
        }
    }, [props.searchValue]);

    return (
        <div
            className={`tree-node ${styles.root} ${
                props.isSelected && props.isSelected
            } mb-1`}
        >
            <div
                className={`${styles.expandIconWrapper} ${
                    props.isSelected && styles.isSelected
                } ${props.isOpen && styles.isOpen}`}
            >
                {props.node.droppable && (
                    <div
                        id={props.node.id.toString()}
                        onClick={(e) => {
                            handleToggle();
                        }}
                    >
                        <i className='mdi mdi-chevron-right' />
                    </div>
                )}
            </div>

            <div className={'checked-custom'}>
                <input
                    className='form-check-input'
                    type='checkbox'
                    checked={props.isSelected}
                    onChange={handleSelect}
                />
            </div>

            <div className='d-flex align-items-center '>
                <div style={{ paddingLeft: 5 }}>
                    {props.node.parent == 0 ? (
                        <img
                            src='/assets/images/menuBar/node_base.svg'
                            alt=''
                            style={{ width: 17 }}
                        />
                    ) : !props.node.droppable ? (
                        <i
                            className='mdi mdi-account '
                            style={{
                                color: '#9F9FA0',
                            }}
                        ></i>
                    ) : (
                        <i
                            className='mdi mdi-account-group text-black'
                            style={{
                                color: '#9F9FA0',
                            }}
                        ></i>
                    )}
                </div>

                <span
                    className='form-check-label'
                    style={{
                        textTransform: 'capitalize',
                        paddingLeft: 5,
                        lineHeight: 1.25,
                        color: '#5D5D5D',
                    }}
                >
                    {props.node.text?.toLowerCase()}{' '}
                    {props?.node.totalByGroup !== ''
                        ? ' [' + props?.node.totalByGroup + ']'
                        : ''}
                </span>
            </div>
        </div>
    );
};
